(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lisse-homepage-beautytherma"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lisse-homepage')) {
  customElements.define('lisse-homepage', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('.lfx-hero-video');
      if (video) {
        video.autoplay = true;
        video.muted = true;
        video.play().catch(() => {});
      }
      const input = this.querySelector('input[type="search"]');
      if (!input || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const examples = JSON.parse(this.dataset.examples);
      let index = 0;
      this.timer = window.setInterval(() => {
        if (!this.isConnected || document.hidden || document.activeElement === input || input.value) return;
        index = (index + 1) % examples.length;
        input.placeholder = examples[index];
      }, 3200);
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
